<script>
	import {beforeUpdate, onMount} from "svelte";
	import Controlador from "../controlador.svelte";
	import {push} from "svelte-spa-router";
	import { docs } from "../store";
	let c;
	onMount(async ()=>{
		c.conectar();
		c.actualizarDocs()
	})
	beforeUpdate(()=>{
		if ($docs.length > 0){
			push("/home");
		}
	})
</script>
<Controlador bind:this={c} />
<div class="w-full h-screen flex items-center justify-center">
	Cargando...
</div>

